//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GetItemName, GetItemSkinName } from "@/tool";
export default {
  name: "BoxLotteryH",
  data() {
    return {
      run_status: 0,
      virtual_case_awards: [],
      animation_end: false,
    };
  },
  beforeDestory() {},
  created() {},
  mounted() {},
  filters: {
    GetItemName,
    GetItemSkinName,
  },  
  methods: {
    /** 乱序奖品池 */
    random_case_awards(items) {
      // 生成一轮奖品
      var result = Array(50)
        .fill(null)
        .map(() => items[parseInt(Math.random() * items.length)]);

      return result;
    },
    reset(items, titem) {
      var randomItems = this.random_case_awards(items); //重置奖品
      randomItems[30] = titem;
      this.virtual_case_awards = randomItems;
      this.animation_end = false;
      this.$refs.scroll.style.transition = "none";
      this.$refs.scroll.style.marginLeft = `0px`;
      this.active_item_index = 3;
      this.run_status = 0;
    },
    async start(lotteryId, items) {
      var titem = items.find((item) => item.name === lotteryId);

      this.reset(items, titem);

      await this.$nextTick();

      setTimeout(() => {
        var main_roll = this.$refs.scroll;
        var award_hit_line = this.$refs.hitline;
        var award_opened = this.$refs[`roll_item_30`][0];

      var move_pixel =
        award_opened.getBoundingClientRect().left -
        award_hit_line.getBoundingClientRect().left - award_hit_line.getBoundingClientRect().width/2;
      var offset_pixel = Math.ceil(award_opened.getBoundingClientRect().width * Math.random());
        var move_pixel_real = move_pixel + offset_pixel;

        main_roll.style.transition = "all 3s cubic-bezier(.17,.67,.43,1)";
        main_roll.style.marginLeft = `-${move_pixel_real}px`;
      }, 100);

      setTimeout(() => {
        this.animation_end = true;
        this.$emit("on_finished");
      }, 4000);
    },
  },
};
